module.exports = __webpack_public_path__ + "img/style_0_12.9717b0cf.png";